import { useMutation } from "react-query";
import { getEmployeesAsyncDownload } from "../../../../../actions/Employees";

const useEmployeeAsyncDownload = () => {
  return useMutation(getEmployeesAsyncDownload);
};

export default useEmployeeAsyncDownload;
